/**
 * @fileoverview Input/output schemas for pov-suggester-v2.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { POV_TYPES } from '@/domains/story-planning/constants';

// =============================================================================
// HOOK INPUT SCHEMA
// =============================================================================

export const HookInputSchema = z.object({
  blurb: z.string().describe('The story blurb to analyze.'),
});

export type HookInput = z.infer<typeof HookInputSchema>;

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema
  .merge(AGENT_SCHEMA_OBJECTS.blurb.schema)
  .merge(AGENT_SCHEMA_OBJECTS.summary.schema)
  .merge(AGENT_SCHEMA_OBJECTS.genre.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  suggestions: z.array(z.object({
    title: z.enum(POV_TYPES as [string, ...string[]]).describe('The name of the suggested POV, chosen from the allowed list.'),
    justification: z.string().describe('A brief explanation of why this POV is a good fit for the given blurb.'),
  })).length(3).describe('An array of exactly three distinct POV suggestions.'),
});

export type Output = z.infer<typeof OutputSchema>;
